import { Injectable, inject } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Injectable()
export class TranslatedPageTitleStrategy extends TitleStrategy {
  private translate = inject(TranslateService);
  private title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot) || 'default_page_title';
    this.translate.get(title).subscribe((title: string) => {
      this.title.setTitle(title);
    });
  }
}
